<template>
  <div
    v-if="!cartVisible && layout == 'grid' && theme && theme.page_sidebar_visible && products.length > 0"
    :style="sideBarStyle"
    :class="`store-sidebar ${layout == 'grid' ? 'show-grid ' : ''} ${visible ? 'show-store-sidebar' : ''}  p-0 position-relative`"
  >
    <div class="p-0 py-1">
      <div class="d-flex d-lg-none justify-content-end w-100">
        <BushelBtn flat variant="primary" class="btn-sm" @click="$emit('hide-sidebar', true)">
          <i class="fa fas fa-times" />
        </BushelBtn>
      </div>
      <StoreFrontSidebarCategoriesFilter
        v-if="categories && theme.page_sidebar_categories_filter_visible"
        title="Categories"
        icon="category"
        multi-select
        :theme="theme"
        :init-collapsed="false"
        :icon-color="theme.page_sidebar_icon_color"
        :title-color="theme.page_sidebar_text_color"
        :selected-checkbox-color="theme.page_sidebar_filter_item_selected_text_color"
        :un-selected-checkbox-color="theme.page_sidebar_filter_item_text_color"
        :filter-border-bottom-color="theme.page_sidebar_filter_border_bottom_color"
        :item-text-color="theme.page_sidebar_filter_item_text_color"
        :selected-text-color="theme.page_sidebar_filter_item_selected_text_color"
        :items="categories"
        @selected="(selected) => $emit('category-selected', selected)"
        @product-type-selected="(selected) => $emit('product-type-selected', selected)"
      />
      <StoreFrontProductFilter
        v-if="features && theme.page_sidebar_features_filter_visible"
        class="custom-fade-in"
        title="Featured Products"
        icon="star"
        :init-collapsed="false"
        :items="features"
        :icon-color="theme.page_sidebar_icon_color"
        :title-color="theme.page_sidebar_text_color"
        :selected-checkbox-color="theme.page_sidebar_filter_item_selected_text_color"
        :un-selected-checkbox-color="theme.page_sidebar_filter_item_text_color"
        :filter-border-bottom-color="theme.page_sidebar_filter_border_bottom_color"
        :item-text-color="theme.page_sidebar_filter_item_text_color"
        :selected-text-color="theme.page_sidebar_filter_item_selected_text_color"
        @selected="(selected) => $emit('featured-selected', selected)"
      />

      <StoreFrontProductFilter
        v-if="strains.length > 1 && theme.page_sidebar_strains_filter_visible"
        class="custom-fade-in"
        title="Strain Type"
        icon="strain"
        :items="strains"
        :init-collapsed="false"
        :icon-color="theme.page_sidebar_icon_color"
        :title-color="theme.page_sidebar_text_color"
        :selected-checkbox-color="theme.page_sidebar_filter_item_selected_text_color"
        :un-selected-checkbox-color="theme.page_sidebar_filter_item_text_color"
        :filter-border-bottom-color="theme.page_sidebar_filter_border_bottom_color"
        :item-text-color="theme.page_sidebar_filter_item_text_color"
        :selected-text-color="theme.page_sidebar_filter_item_selected_text_color"
        @selected="(selected) => $emit('strain-selected', selected)"
      />
      <StoreFrontProductFilter
        v-if="brands.length > 0 && theme.page_sidebar_brands_filter_visible"
        class="custom-fade-in"
        title="Brands"
        icon="brand"
        :items="brands"
        :init-collapsed="false"
        :icon-color="theme.page_sidebar_icon_color"
        :title-color="theme.page_sidebar_text_color"
        :selected-checkbox-color="theme.page_sidebar_filter_item_selected_text_color"
        :un-selected-checkbox-color="theme.page_sidebar_filter_item_text_color"
        :filter-border-bottom-color="theme.page_sidebar_filter_border_bottom_color"
        :item-text-color="theme.page_sidebar_filter_item_text_color"
        :selected-text-color="theme.page_sidebar_filter_item_selected_text_color"
        @selected="(selected) => $emit('brand-selected', selected)"
      />
      <StoreFrontProductFilter
        v-if="isMedRecCompany() && theme.page_sidebar_med_rec_filter_visible"
        class="custom-fade-in"
        title="Industry"
        icon="med/rec"
        :items="industries"
        :init-collapsed="false"
        :icon-color="theme.page_sidebar_icon_color"
        :title-color="theme.page_sidebar_text_color"
        :selected-checkbox-color="theme.page_sidebar_filter_item_selected_text_color"
        :un-selected-checkbox-color="theme.page_sidebar_filter_item_text_color"
        :filter-border-bottom-color="theme.page_sidebar_filter_border_bottom_color"
        :item-text-color="theme.page_sidebar_filter_item_text_color"
        :selected-text-color="theme.page_sidebar_filter_item_selected_text_color"
        @selected="(selected) => $emit('industry-selected', selected)"
      />

      <StoreFrontProductFilter
        v-if="cannabinoids.length > 1 && theme.page_sidebar_cannabanoids_filter_visible"
        class="custom-fade-in"
        title="Cannabinoids"
        icon="canna"
        :items="cannabinoids"
        :init-collapsed="false"
        :icon-color="theme.page_sidebar_icon_color"
        :title-color="theme.page_sidebar_text_color"
        :selected-checkbox-color="theme.page_sidebar_filter_item_selected_text_color"
        :un-selected-checkbox-color="theme.page_sidebar_filter_item_text_color"
        :filter-border-bottom-color="theme.page_sidebar_filter_border_bottom_color"
        :item-text-color="theme.page_sidebar_filter_item_text_color"
        :selected-text-color="theme.page_sidebar_filter_item_selected_text_color"
        @selected="(selected) => $emit('cannabinoid-selected', selected)"
      />

      <StoreFrontProductFilterRange
        v-if="company && !company.merchandise_company"
        class="custom-fade-in"
        title="Potency"
        icon="canna"
        :min="min"
        :max="max"
        :init-collapsed="false"
        :icon-color="theme.page_sidebar_icon_color"
        :title-color="theme.page_sidebar_text_color"
        :filter-border-bottom-color="theme.page_sidebar_filter_border_bottom_color"
        :item-text-color="theme.page_sidebar_filter_item_text_color"
        :selected-text-color="theme.page_sidebar_filter_item_selected_text_color"
        :btn-color="theme.page_sidebar_btn_color"
        :btn-active-color="theme.page_sidebar_btn_active_color"
        :btn-text-color="theme.page_sidebar_btn_text_color"
        :btn-active-text-color="theme.page_sidebar_btn_text_active_color"
        @selected="(selected) => $emit('potency-selected', selected)"
      />

      <StoreFrontSidebarPriceFilter
        v-if="!hidePrices && theme.page_sidebar_price_filter_visible"
        class="custom-fade-in"
        title="Price Range"
        icon="price"
        :items="priceRanges"
        :init-collapsed="false"
        :icon-color="theme.page_sidebar_icon_color"
        :title-color="theme.page_sidebar_text_color"
        :selected-checkbox-color="theme.page_sidebar_filter_item_selected_text_color"
        :un-selected-checkbox-color="theme.page_sidebar_filter_item_text_color"
        :filter-border-bottom-color="theme.page_sidebar_filter_border_bottom_color"
        :item-text-color="theme.page_sidebar_filter_item_text_color"
        :selected-text-color="theme.page_sidebar_filter_item_selected_text_color"
        @selected="(selected) => $emit('price-range-selected', selected)"
      />
      <StoreFrontSidebarPreOrderFilter
        v-if="theme.page_sidebar_pre_order_filter_visible"
        class="custom-fade-in"
        title="Availability"
        icon="price"
        :items="availabilty"
        :init-collapsed="false"
        :theme="theme"
        :selected-text-color="theme.page_sidebar_filter_item_selected_text_color"
        @selected="(selected) => $emit('pre-order-selected', selected)"
        @sub-item-selected="(subselected) => $emit('pre-order-sub-item-selected', subselected)"
      />
    </div>
  </div>
</template>
<script>
import StoreFrontProductFilter from "@/components/storefront/StoreFrontProductFilter.vue";
import StoreFrontSidebarPriceFilter from "./StoreFrontSidebarPriceFilter.vue";
import StoreFrontSidebarPreOrderFilter from "./StoreFrontSidebarPreOrderFilter.vue";
import StoreFrontSidebarCategoriesFilter from "./StoreFrontSidebarCategoriesFilter.vue";
import StoreFrontProductFilterRange from "@/components/storefront/StoreFrontProductFilterRange.vue";

export default {
  name: "StoreFrontSidebar",
  components: {
    StoreFrontProductFilter,
    StoreFrontSidebarPriceFilter,
    StoreFrontSidebarPreOrderFilter,
    StoreFrontSidebarCategoriesFilter,
    StoreFrontProductFilterRange,
  },
  props: {
    company: { type: Object },
    categories: { type: Array, required: true },
    products: { type: Array, required: true },
    productTypes: { type: Array },
    strains: { type: Array },
    brands: { type: Array },
    cannabinoids: { type: Array },
    priceRanges: { type: Array },
    availabilty: { type: Array },
    industries: { type: Array },
    medRedItems: { type: Array },
    features: { type: Array },
    filteredProducts: { type: Array },
    category: { type: String },
    theme: { type: Object },
    hidePrices: { type: Boolean, default: false },
    layout: { type: String },
    visible: { type: Boolean, default: true },
    cartVisible: { type: Boolean, default: true },
    width: { type: String, default: "300px" },
  },
  emits: [
    "category-selected",
    "product-type-selected",
    "strain-selected",
    "brand-selected",
    "industry-selected",
    "cannabinoid-selected",
    "price-range-selected",
    "featured-selected",
    "potency-selected",
    "pre-order-selected",
    "pre-order-sub-item-selected",
  ],
  data() {
    return {
      min: 0,
      max: 150,
    };
  },
  computed: {
    sideBarStyle() {
      return {
        width: this.width,
        backgroundColor: this.theme.page_sidebar_background_color,
        zIndex: 2,
        borderRight: `${this.theme.page_sidebar_border_color} 1px solid`,
        boxShadow: this.theme.page_sidebar_box_shadow_visible ? "0 0.5rem 1rem rgba(0, 0, 0, 0.05)" : null,
        position: "relative",
        top: 0,
        minHeight: "100%", // ba should of been minHeight.
      };
    },
  },
  mounted() {
    const sp = document.querySelector(".store-page");
    if (sp) {
      sp.addEventListener("scroll", this.handleScroll);
    }
  },
  unmounted() {
    const sp = document.querySelector(".store-page");
    if (sp) {
      sp.removeEventListener("scroll", this.handleScroll);
    }
  },
  methods: {
    isMedRecCompany() {
      let isMedical = false;
      let isRecreactional = false;
      if (this.company.operations && this.company.operations.length > 0) {
        this.company.operations.forEach((operation) => {
          if (operation.industry && operation.industry == "Recreational") {
            isRecreactional = true;
          }
          if (operation.industry && operation.industry == "Medical") {
            isMedical = true;
          }
        });
        return isMedical && isRecreactional;
      }
      return false;
    },
    alphabicalSort(a, b) {
      if (a < b) return -1;
      if (a > b) return 1;
      return 0;
    },
  },
};
</script>

<style scoped>
.store-sidebar {
  min-height: 100%;
  margin-left: -300px !important;
  transition: margin-left 1s;
}
@media only screen and (max-width: 992px) {
  .store-sidebar {
    height: 100% !important;
    margin-left: -100% !important;
    transition: margin-left 1s;
    position: fixed !important;
    z-index: 1030 !important;
    overflow: auto;
  }
}
.show-store-sidebar {
  margin-left: 0 !important;
}
:deep(.price-range-input) {
  height: 30px !important;
}
</style>
